import httpClient from "../axiosBase/axiosHandler";

export const sendChatMessage = (data) => {
  return httpClient.post("/ai/chat/message/", data);
};

export const getAiUnitBalance = () => {
  return httpClient.get("/ai/billing/units/");
};

export const getConversationList = () => {
  return httpClient.get("/ai/conversations/list/");
};

export const getConversationDetail = (id) => {
  return httpClient.get(`/ai/conversations/${id}/detail/`);
};

export const updateConversationTitle = (id, data) => {
  return httpClient.patch(`/ai/conversations/${id}/title/`, data);
};

export const deleteConversation = (id) => {
  return httpClient.delete(`/ai/conversations/${id}/delete/`);
};
